import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
}

export default {
  'batch_number': {
    title: '批次号',
    type: 'input',
    equation: all,
    slot: true
  },
  'file_name': {
    title: '附件名称',
    type: 'input',
    equation: cusname,
    slot: true,
    width: 'auto'
  },
  'batch_type': {
    describe: true,
    title: '批导类型',
    type: 'select',
    equation: city,
    dictionary: 'A0029',
    width: '220'
  },
  'batch_status': {
    describe: true,
    title: '批导处理状态',
    type: 'select',
    equation: city,
    dictionary: 'A0030',
    width: '120'
  },
  'batch_name': {
    title: '批导人',
    type: 'input',
    equation: all,
    width: '120'
  },
  'datum': {
    title: '批导日期',
    type: 'date',
    slot: true,
    equation: all,
    defaultVal: new Date(),
    width: '120'
  },
  'uzeit': {
    title: '批导时间',
    type: 'time',
    slot: true,
    equation: all,
    width: '120'
  }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/BatchQuery.js